import DeviceLogTypeBadge from '@/components/device-log/device-log-type-badge';
import DeviceLogDetailDialog from '@/components/device-log/device-log-detail-dialog';
import type { IClientDeviceLog } from '@/entities/client.entity';
import { getDeviceLogTypeMeta } from '@/entities/device-log-type-meta';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import TimeAgo from 'react-timeago';
import russianStrings from 'react-timeago/lib/language-strings/ru';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';

const formatter = buildFormatter(russianStrings);

interface ClientDeviceLogCardProps {
	deviceLog: IClientDeviceLog;
	className?: string;
	sdkVersion?: string;
}

export default function ClientDeviceLogCard({ deviceLog, className, sdkVersion }: ClientDeviceLogCardProps) {
	const [detailOpen, setDetailOpen] = useState(false);
	const meta = getDeviceLogTypeMeta(deviceLog.logType);

	return (
		<>
			<button
				type='button'
				className={cn(
					'w-full text-left rounded-lg border border-border bg-card p-2.5 shadow-sm border-l-[3px]',
					meta.borderClass,
					className,
				)}
				onClick={() => setDetailOpen(true)}
			>
				<div className='flex items-start justify-between gap-2'>
					<DeviceLogTypeBadge logType={deviceLog.logType} />
					<span className='text-xs text-muted-foreground shrink-0'>
						<TimeAgo date={deviceLog.occurredAt} formatter={formatter} />
					</span>
				</div>

				<p className='mt-1.5 text-sm leading-snug line-clamp-2 break-words'>{deviceLog.message}</p>

				{deviceLog.threadName ? <p className='mt-1 text-xs text-muted-foreground truncate'>{deviceLog.threadName}</p> : null}
			</button>

			<DeviceLogDetailDialog log={deviceLog} open={detailOpen} onOpenChange={setDetailOpen} sdkVersion={sdkVersion} />
		</>
	);
}
